import { User, UserPartnerAssociation } from "dataTypes/user/user";
import { ApiEndpoints, secureAxios, stringifyParams } from "utilities/apiService";

export const setCurrentPartner = (partnerId: number) =>
  secureAxios.post<User>(ApiEndpoints.SetCurrentPartner + stringifyParams({ partnerId }));

export const getActivePartners = () => secureAxios.get<UserPartnerAssociation[]>(ApiEndpoints.GetActivePartners);
